/**
 * @author Matthew Rogers
 * Controller for MYSA Opportunity Log admin page
 */
var MYSADMTViewController = (function () {
    function MYSADMTViewController(env, socket, $scope, Dialog, notify, $state) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.$state = $state;
        this.loaded = { inbound: false, outbound: false, opp: false, ready: false };
        this.serverError = undefined;
        this.defects = { inbound: undefined, outbound: undefined, total: 0 };
        this.filter = { defectIN: '', defectOUT: '' };
        this.oppLog = { log: undefined, notfound: false, searching: { in: {}, out: {}, opp: false }, opp: '', oppty: '', in: [], out: [] };
        // Listener for the inbound and outbound defects to arrive
        this.socket.forward('mysa.mysadmt-defects', this.$scope);
        this.$scope.$on('socket:mysa.mysadmt-defects', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                // Flash the error and go back to admin view
                _this.notify.error(payload.error);
                $state.go('admin.main');
            }
            else {
                _this.defects[payload.type] = payload.data;
                _this.loaded[payload.type] = true;
                _this.areWeReady();
            }
        });
        // Listener for the opp log retrieval to arrive
        this.socket.forward('mysa.mysadmt-opp-log', this.$scope);
        this.$scope.$on('socket:mysa.mysadmt-opp-log', function (event, payload) {
            // console.info(payload);
            _this.oppLog.searching = { in: {}, out: {}, opp: false }; // Reset search button
            if (angular.isDefined(payload.error)) {
                // this.serverError = payload.error;
                _this.notify.error(payload.error);
            }
            else if (!angular.isDefined(payload.data)) {
                _this.oppLog.notfound = true;
            }
            else {
                _this.oppLog.in = payload.data.logEntriesInBound;
                _this.oppLog.out = payload.data.logEntriesOutBound;
                _this.oppLog.oppty = payload.data._id.substr(payload.data._id.indexOf('LOG-') + 4);
                _this.loaded.opp = true;
            }
        });
    }
    /**
     * Function to view the details of the inbound or outbound log details in a pop-up
     * @param entry - Object - the entire log details
     * @param inout - String - whether Inbound or Outbound log
     */
    MYSADMTViewController.prototype.viewLog = function (event, entry, inout) {
        // Object containing details for the pop-up
        var items = {
            logBundle: {
                log: JSON.stringify(entry, undefined, 4),
                opp: this.oppLog.oppty,
                time: this.getDate(entry.timestamp),
                module: entry.module,
                success: entry.success,
                message: entry.message.info ? entry.message.info : entry.message,
                io: inout
            }
        };
        // Display pop-up
        this.Dialog.updateValidForm(event, items, 'mysa-dmt-viewlog.html');
    };
    /**
     * Function fired when initially inbound or outbound data is received.  Only if both are loaded, will the
     * page detail appear
     */
    MYSADMTViewController.prototype.areWeReady = function () {
        if (this.loaded.inbound && this.loaded.outbound) {
            this.defects.total = this.defects.inbound.length + this.defects.outbound.length;
            this.loaded.ready = true;
        }
    };
    /**
     * Function to collect an opportunity's log document from cloudant - could be called via the search button, or
     * when selecting from the defect list
     * @param oppNum - String - the opportunity number
     * @param index - Number - the index number of the defect selected by the user
     */
    MYSADMTViewController.prototype.retrieveLog = function (oppNum, index, io) {
        // Set search flag accordingly
        if (angular.isDefined(index)) {
            this.oppLog.searching[io][index] = true;
        }
        else {
            this.oppLog.searching.opp = true;
        }
        this.oppLog.notfound = false; // reset
        // Make call to server
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getLogByOpp',
                opp: oppNum,
                script: '/admin/mysa-dmt/mysa-dmt',
                user: this.env.user
            }
        });
    };
    MYSADMTViewController.prototype.getDate = function (date) {
        return new Date(date);
    };
    MYSADMTViewController.prototype.getTitle = function (log) {
        if (log.message.success) {
            return 'INFO: ' + log.message.info + '\n\nClick to display full log details';
        }
        else {
            if (log.message.info) {
                return 'INFO: ' + log.message.info + '\nERROR: ' + log.message.errors + '\n\nClick to display full log details';
            }
            else {
                return 'ERROR: ' + log.message + '\n\nClick to display full log details';
            }
        }
    };
    MYSADMTViewController.prototype.$onInit = function () {
        var _this = this;
        // Make calls to get the outbound and inbound defects
        var defects = ['mysa-dmt-defective-outbound', 'mysa-dmt-defective-inbound'];
        angular.forEach(defects, function (viewName) {
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getMYSA2DMTFailures',
                    script: '/admin/mysa-dmt/mysa-dmt',
                    view: viewName,
                    user: _this.env.user
                }
            });
        });
    };
    MYSADMTViewController.$inject = ['env', 'socket', '$scope', 'Dialog', 'notify', '$state'];
    return MYSADMTViewController;
}());
var MYSADMTViewComponent = (function () {
    function MYSADMTViewComponent() {
        this.templateUrl = 'mysa-dmt-view.html';
        this.controllerAs = 'vm';
        this.controller = MYSADMTViewController;
    }
    return MYSADMTViewComponent;
}());
angular
    .module('application')
    .component('viewMysaDmtSection', new MYSADMTViewComponent());

//# sourceMappingURL=mysa-dmt.view.component.js.map
